import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import SwipeableViews from 'react-swipeable-views'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  conversionTitle: {
    display: 'block',
    textTransform: 'none',
  },
  conversionTotal: {
    display: 'block',
    fontSize: 23,
    lineHeight: 1.2,
  },
  tabsRoot: {
    marginTop: 10,
  },
  tabsFlexContainer: {
    justifyContent: 'center',
  },
  tabSlide: {},
})

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{ height: '100%', position: 'relative' }}
    >
      {children}
    </Typography>
  )
}

class MTabs extends Component {
  state = {
    valueTab: 0,
  }

  handleChangeTab = (event, valueTab) => {
    this.setState({ valueTab })
  }

  handleChangeIndex = index => {
    this.setState({ valueTab: index })
  }

  render() {
    const { classes, theme, tabs, container } = this.props
    const { valueTab } = this.state

    return (
      <Fragment>
        <AppBar position="static" color="inherit" elevation={0}>
          <Tabs
            value={valueTab}
            onChange={this.handleChangeTab}
            indicatorColor="secondary"
            textColor="inherit"
            variant="scrollable"
            scrollButtons="off"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
              flexContainer: classes.tabsFlexContainer,
            }}
          >
            {tabs}
          </Tabs>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={valueTab}
            onChangeIndex={this.handleChangeIndex}
            slideClassName={classes.tabSlide}
            containerStyle={{
              height: '100%',
            }}
            style={{
              top: 140,
              left: 10,
              right: 20,
              bottom: 15,
              position: 'absolute',
            }}
          >
            {container}
          </SwipeableViews>
        </AppBar>
      </Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(MTabs)
